import { t, type StringKey } from '../strings';
import { VISIT_NOTE_FILE_TYPE_NAME } from './seededFileTypes';

/**
 * 🔒 Decision 13311 (T3835, the owner's note on P2a: *"Change the label to be more explicit that this is for visit photo
 * uploads"*): the line a type's Settings rows carry saying what the application files under it, keyed to the type's name
 * constant, so a later rename of the type (row T3877) carries its line with it. A type the application does not name here
 * carries none.
 */
const FILE_TYPE_PURPOSE_KEYS: Readonly<Record<string, StringKey>> = {
  [VISIT_NOTE_FILE_TYPE_NAME]: 'settings.fileTypes.purpose.visitNote',
};

/** The line saying what a type is for, or null where the application names none for it. */
export function fileTypePurpose(name: string): string | null {
  const key = FILE_TYPE_PURPOSE_KEYS[name];
  return key ? t(key) : null;
}
